import { IApplicationState } from '../../types/redux';
import { IAdvertisementShelf } from '../../repositories/price-estimator/entities/shelf/AdvertisementShelf';

export function selectServices(state: IApplicationState): IAdvertisementShelf[] {
  return state.services.data;
}
